<div class="d-flex justify-content-end">
    <i (click)="closeModal()" class="icon icon-edponline-Bop-071 tooltip-icon" aria-hidden="true"></i>
</div>
<div>
    <div [innerHTML]="data.messageHTML | translate"></div>
</div>
